import React from "react";
import { Skeleton } from "../Skeleton";
import { AnalysisItem } from "../AnalysisItem";
import { InfoLabel } from "../InfoLabel";
import css from "./InsightsAnalysis.module.scss";

export interface InsightsAnalysisProps {
  isLoading: boolean;
  value: string | null;
}

const InsightsAnalysis: React.FC<InsightsAnalysisProps> = ({ isLoading, value }) => {
  const attrs = {
    analysisItem: {
      isLoading,
      title: "Insights",
    },
    container: {
      className: css.container,
    },
    infoLabel: {
      text: "No data to display yet",
      tooltip: "Insights cannot be determined yet",
    },
  };

  if (isLoading) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <Skeleton />
        </div>
      </AnalysisItem>
    );
  }

  if (!value) {
    return (
      <AnalysisItem {...attrs.analysisItem}>
        <div {...attrs.container}>
          <InfoLabel {...attrs.infoLabel} />
        </div>
      </AnalysisItem>
    );
  }

  return (
    <AnalysisItem {...attrs.analysisItem}>
      <div {...attrs.container}>{value}</div>
    </AnalysisItem>
  );
};

export default InsightsAnalysis;
